import { SystemStyleObjectRecord } from '@chakra-ui/theme/dist/types/theme.types';

export const TextStyles: SystemStyleObjectRecord = {
  category: {
    primary: {
      textTransform: 'uppercase',
      fontWeight: 'semibold',
      color: 'gray.600',
      fontSize: 'sm',
    },
  },

  guestsSelector: {
    numberOfChildren: {
      information: {
        color: 'gray.600',
        fontSize: 'xs',
        userSelect: 'none',
      },
    },
  },
  chakraSelect: {
    button: {
      headline: {
        color: 'gray.600',
        fontSize: 'xs',
        fontStyle: 'italic',
      },
    },
    menuList: {
      addSubItem: {
        hint: {
          fontStyle: 'italic',
          color: 'gray.400',
          fontSize: 'xs',
          userSelect: 'none',
        },
      },
    },
  },
};
